module.exports = __webpack_public_path__ + "f1521c4d80a424ca00821c59c4ea162c.png";